import * as React from "react";
import * as ReactDom from "react-dom";
import { baseUrl } from "./apiConfig";
import { AppProvider } from "./AppProvider";
import "./index.css";
import { initTranslator } from "./locales";
import "./locales";
import { PublicApp } from "./PublicApp";
import "filepond/dist/filepond.min.css";

initTranslator(baseUrl);

ReactDom.render(
  <AppProvider autoLoginAzureAd={false}>
    <PublicApp />
  </AppProvider>,
  document.getElementById("root-public-app")
);
